import { BaseFormService } from '/@/modules/core/form/services/BaseFormService';
import Lang from '/@/modules/core/app/services/Lang';
import Logger from '/@/modules/core/app/helpers/Logger';
import { BaseFlowFormOptions } from '@/modules/core/form/models/configs/BaseFlowFormOptions';

/* eslint-disable no-unused-vars */
export class BaseFlowFormService extends BaseFormService {
  options;

  constructor(options = {}) {
    super();

    this.options = new BaseFlowFormOptions(options);
  }

  /**
   * @abstract
   * @returns BaseModel
   */
  getModel() {
    Logger.log('getModel() must be implemented', Logger.LEVEL_ERROR);
  }

  /**
   * @abstract
   * @returns string
   */
  getRoute() {
    Logger.log('getRoute() must be implemented', Logger.LEVEL_ERROR);
  }

  /**
   * @abstract
   * @returns {Promise<Component>|AsyncComponent}
   */
  getFirstComponent() {
    Logger.log('getFirstComponent() must be implemented', Logger.LEVEL_ERROR);
  }

  /**
   * @param form
   * @returns {Promise<Component>|AsyncComponent}
   */
  getLastComponent(form) {
    return undefined;
  }

  /**
   * @param component
   * @returns {Promise<Component>|null}
   */
  getFaqComponent(component) {
    return null;
  }

  /**
   * @returns {Promise<Component>|null}
   */
  getUpgradeComponent() {
    return null;
  }

  /**
   * @returns {?Vue.Component|{}}
   */
  getSidePanelComponent() {
    return null;
  }

  getSaveMessage(data) {
    return Lang.t('core.saved-successfully');
  }

  /**
   * @returns {ModalOptions}
   */
  async getPostSubmitModalOptions(data) {
    return null;
  }

  /**
   * @returns {number|null}
   */
  getModalCloseDelay() {
    return null;
  }

  // always use arrow function to pass this function as parameter to modal mixin
  // Ex: () => this.service.onModalClose()
  async onModalClose() {}

  canShowSidePanel() {
    return !!this.options.sidePanelConfig;
  }

  /**
   * @param {boolean} value
   */
  setIsFlowCompleted(value) {
    this.options.isFlowCompleted = value;
  }

  /**
   * @param {boolean} panelState
   */
  toggleSidePanel(panelState) {
    this.options.sidePanelConfig.open = panelState;
  }
}
